/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RedemptionList } from './RedemptionList';
import {
    RedemptionListFromJSON,
    RedemptionListFromJSONTyped,
    RedemptionListToJSON,
} from './RedemptionList';

/**
 * 
 * @export
 * @interface PaginatedRedemptionListList
 */
export interface PaginatedRedemptionListList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedRedemptionListList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedRedemptionListList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<RedemptionList>}
     * @memberof PaginatedRedemptionListList
     */
    results: Array<RedemptionList>;
}

/**
 * Check if a given object implements the PaginatedRedemptionListList interface.
 */
export function instanceOfPaginatedRedemptionListList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function PaginatedRedemptionListListFromJSON(json: any): PaginatedRedemptionListList {
    return PaginatedRedemptionListListFromJSONTyped(json, false);
}

export function PaginatedRedemptionListListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedRedemptionListList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(RedemptionListFromJSON)),
    };
}

export function PaginatedRedemptionListListToJSON(value?: PaginatedRedemptionListList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(RedemptionListToJSON)),
    };
}

